import React from 'react';
import { Section } from './Section';
import { SectionCta } from './SectionCta';
const consequences = ['More appointments', 'More chair time', 'More frustration', 'Lower profitability'];
const approach = ['Identify the risk before treatment.', 'Plan with clinical judgment.', 'Monitor the case before it goes off track.', 'Intervene before a refinement becomes the only option.'];
export function ProblemIntro() {
  return <Section eyebrow="The real cost" title="Stop losing time to unnecessary refinements" intro="You didn’t start offering aligner treatment to spend your schedule fixing problems that could have been prevented during planning." alt data-id="element-181" data-mp="8gwzpd2zzxi0">
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4" data-id="element-182" data-mp="3p6pd74299ql">
        {consequences.map(item => <div key={item} className="rounded-2xl border border-red-500/20 bg-red-500/[0.07] px-3 py-4 text-center text-xs font-bold uppercase leading-snug tracking-wide text-red-200 sm:text-sm" data-id="element-183" data-mp="rf0x5a9iw83z">
            {item}
          </div>)}
      </div>

      <p className="mt-8 text-center text-sm font-semibold text-white/80 sm:text-base" data-id="element-184" data-mp="bzf3xb38nq7u">
        The Anti-Refinement System™ was created to help you approach aligner cases differently:
      </p>

      <ul className="mx-auto mt-5 grid max-w-3xl gap-3 sm:grid-cols-2" data-id="element-185" data-mp="lxcq7t1jfcxt">
        {approach.map((item, i) => <li key={item} className="flex items-start gap-3 rounded-2xl border border-white/10 bg-white/[0.03] p-4" data-id="element-186" data-mp="zny8pgn2xkv6" data-mpi={i}>
            <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-lime text-xs font-black text-black" data-id="element-187" data-mp="urhd61djw482">
              {i + 1}
            </span>
            <span className="text-sm leading-snug text-white/80" data-id="element-188" data-mp="14o3x8ny1yr91">{item}</span>
          </li>)}
      </ul>

      <SectionCta headline="Start planning cases with a system instead of hoping they track." data-id="element-189" data-mp="3beae30znsi35" />
    </Section>;
}